<template>
  <div class="qrcode_dialog_content">
    <div class="print_btn">
      <el-button type="primary">打 印</el-button>
    </div>
    <div class="asset_content">
      <div class="asset_content_title">{{titleName}}</div>
      <div class="asset_content_info">
        <div class="asset_content_qrcode" id='qrcode'>
        </div>
        <template v-for="item of optionList" >
          <div class="asset_content_item">
            <div class="asset_content_item_left">{{item.name || '-'}}</div>
            <div class="asset_content_item_right">{{item.value || '-'}}</div>
          </div>
        </template>
        <div v-if="optionList.length <= 0" class="asset_content_item">
          <div class="asset_content_item_left">-</div>
          <div class="asset_content_item_right">-</div>
        </div>
        <div v-if="optionList.length <= 1" class="asset_content_item">
          <div class="asset_content_item_left">-</div>
          <div class="asset_content_item_right">-</div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import QRcode from 'qrcodejs2'

  /*
      数据demo
   *this.qrCodeData = {
          titleName: '物料信息',
          httpText: {
            key: 'MAT',
            valList: [this.matInfo.matCode]
          },
          optionList: [
            {
              name: '物料名称',
              value: this.matInfo.matName,
            },
            {
              name: '物料编码',
              value: this.matInfo.matCode,
            }
          ]
        }
   */
  export default {

    props: ['qrCodeData'],
    data () {
      return {
        titleName: '',
        httpText: {},
        optionList: [],
        oneFlag: true
      }
    },
    created () {
      let qrCodeData = this.qrCodeData || {}
      this.titleName = qrCodeData.titleName || '-'
      this.httpText = qrCodeData.httpText || ''
      this.optionList = qrCodeData.optionList || []
    },
    mounted () {
      this.getQrCode()
    },
    methods: {
      getQrCode () {
        if (this.httpText) {
          this.$axios.post(this.$url.getQrCode, this.httpText).then(res => {
            if (this.oneFlag) {
              this.oneFlag = false
              new QRcode('qrcode', {
                width: 100,
                height: 100, // 高度
                text: res.data.text, // 二维码内容
                errorCorrectionLevel:'M'
              })
            }
          })
        }
      },
    }
  }
</script>
<style scoped lang="scss">
  .qrcode_dialog_content {

    .print_btn {
      width: 100%;
      text-align: center;
    }

    .asset_content {
      width: 400px;
      border: 1px solid #333333;
      margin: 0 auto;
      margin-top: 30px;
      line-height: 60px;

      .asset_content_title {
        font-size: 16px;
        text-align: center;
      }

      .asset_content_info {
        position: relative;

        .asset_content_qrcode {
          width: 100px;
          height: 100px;
          padding:10px 10px;
          padding-bottom: 10px;
          position: absolute;
          top: 1px;
          right: 0px;
          background: #ffffff;
          border-left: 1px solid #333333;
          overflow: hidden;

          img {
            width: 100px;
            height: 100px;
          }

        }
      }

      .asset_content_item {
        border-top: 1px solid #333333;
        text-indent: 1em;

        .asset_content_item_left {
          float: left;
          // width: 100px;
          min-width: 90px;
          // padding-right: 10px;
          border-right: 1px solid #333333;
        }

      }
    }
  }
</style>
